<ng-template #content let-modal>
    <div class="modal-header bg-dark">
        <h5 class="modal-title" id="editClienteLabel">Actualizar cliente</h5>
        <button type="button" class="close text-light" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="clienteForm" *ngIf="clienteForm">
        <div class="modal-body p-0">
            <input type="hidden" id="edit" name="edit" />
            <input type="hidden" id="edit_idCliente" name="edit_idCliente"
                [formControl]="clienteForm.get('id_cliente')" />
            <input type="hidden" id="edit_idDireccion" name="edit_idDireccion"
                [formControl]="clienteForm.get('id_direccion')" />
            <div class="card card-tabs m-0">
                <div class="card-header p-0 pt-1 border-bottom-0">
                    <ul class="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="custom-tabs-three-personal-tab" data-toggle="pill"
                                href="#custom-tabs-three-personal" role="tab" aria-controls="custom-tabs-three-personal"
                                aria-selected="true">Datos Personales</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="custom-tabs-three-direccion-tab" data-toggle="pill"
                                href="#custom-tabs-three-direccion" role="tab" aria-controls="custom-tabs-three-direccion"
                                aria-selected="false">Direcciones</a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content" id="custom-tabs-three-tabContent">
                        <div class="tab-pane fade active show" id="custom-tabs-three-personal" role="tabpanel"
                            aria-labelledby="custom-tabs-three-personal-tab">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="InputNombre">Nombre</label>
                                        <input type="text" class="form-control" id="edit_InputNombre" name="edit_InputNombre"
                                            [formControl]="clienteForm.get('nombre')" placeholder="Ingresar nombre" autocomplete="off">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="InputApellido">Apellido</label>
                                        <input type="text" class="form-control" id="edit_InputApellido" name="edit_InputApellido"
                                            [formControl]="clienteForm.get('apellido')" placeholder="Ingresar apellido"
                                            autocomplete="off">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="InputEmail">Email</label>
                                        <input type="email" class="form-control" id="edit_InputEmail" name="edit_InputEmail"
                                            [formControl]="clienteForm.get('email')" placeholder="xxxxxxx@xxxxx.xx" autocomplete="off">
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="InputTelefono">Teléfono</label>
                                        <input type="text" class="form-control" id="edit_InputTelefono" name="edit_InputTelefono"
                                            [formControl]="clienteForm.get('telefono')" placeholder="+569xxxxxxxx" autocomplete="off">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="habilitado">Estado</label>
                                        <div class="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                            <input type="checkbox" class="custom-control-input" id="edit_habilitado"
                                                name="edit_habilitado" [formControl]="clienteForm.get('habilitado')">
                                            <label class="custom-control-label" for="edit_habilitado"
                                                id="edit_habilitadoText">{{clienteForm.get('habilitado').value ? "Habilitado" :
                                                "Deshabilitado"}}</label>
                
                                            <input type="hidden" id="edit_habilitado_val" name="edit_habilitado_val" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="custom-tabs-three-direccion" role="tabpanel"
                            aria-labelledby="custom-tabs-three-direccion-tab">
                            <div class="row">
                                <div class="col-12">
                                    <!-- <h5>Direcciones</h5> -->
                                    <app-add-direccion [id_cliente]="cliente.id_cliente"
                                        (updateData)="getDirecciones()"></app-add-direccion>
                                    <table class="table">
                                        <tr>
                                            <th>Dirección</th>
                                            <th>Detalle</th>
                                            <th>Comuna</th>
                                            <th></th>
                                        </tr>
                                        <tr *ngFor="let item of cliente.direccions">
                                            <td>{{item.direccion}}</td>
                                            <td>{{item.detalle}}</td>
                                            <td>{{item.comuna_nombre}}</td>
                                            <td>
                                                <app-upd-direccion [buttonOnlyIcon]="true" [id_cliente]="cliente.id_cliente"
                                                    [dataDireccion]="item" (updateData)="getDirecciones()"></app-upd-direccion>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-outline-success" (click)="modal.close(clienteForm.value)"
                [disabled]="!clienteForm.valid">
                <i class="fas fa-user-edit"></i> Actualizar
            </button>
            <button type="button" class="btn btn-outline-danger" (click)="modal.dismiss('Cancel')"><i
                    class="fas fa-times"></i>
                Cancelar</button>
        </div>
    </form>
</ng-template>

<button type='button' (click)="open(content)" class='btn btn-link btn-sm'>
    <i class='fas fa-user-edit text-light'></i>
</button>